import { ReportConfig } from 'application/Shared/types/reports';

export const allReportsConfig: ReportConfig[] = [
    {
        checkboxes: [
            {
                reportEndpoint: 'accountsInventory',
                subOptions: [
                    { key: 'AccountSummary' },
                    { key: 'AccountOverview' }
                ],
                type: 'AccountsInventory'
            }
        ],
        hidden: false,
        setup: {
            advancedReportSelectionOptions: {
                disableBrowsersSelection: true,
                disableInactiveSelection: true,
                disablePersonalSelection: true,
                disableUnclassifiedSelection: true,
                excludeDormantSelection: true,
                excludePersonalAccountsSelection: true
            },
            appSelectionOptions: null,
            businessOwnerSelection: false,
            canBeShownAtPartnerLevel: true,
            clientSelection: false,
            multiAppSelectionOptions: {
                allSelection: true,
                appSelection: true,
                categorySelection: true,
                lifecycleStageSelection: true,
                managementStageSelection: true,
                platformSelection: true,
                subCategorySelection: true,
                tagSelection: true
            },
            subReportSelection: true,
            tagSelection: false,
            timePeriodSelection: true,
            userSelectionOptions: {
                allSelection: true,
                groupsSelection: true,
                usersSelectionOptions: {
                    multi: true
                }
            },
            vendorIncidentSelection: false
        },
        type: 'accountsInventory'
    },
    {
        checkboxes: [
            {
                reportEndpoint: 'discovery',
                subOptions: [
                    { key: 'Overview' },
                    { key: 'RiskAnalysis' },
                    { key: 'OverviewBreakdown' },
                    {
                        key: 'ApplicationBreakdown',
                        options: [
                            {
                                key: 'expandUserDetails',
                                tooltip: 'Tooltips.Reports.expandUserDetails'
                            }
                        ]
                    }
                ],
                type: 'Discovery'
            }
        ],
        hidden: false,
        setup: {
            advancedReportSelectionOptions: {
                disableBrowsersSelection: true,
                disableInactiveSelection: true,
                disablePersonalSelection: true,
                disableUnclassifiedSelection: true,
                excludeDormantSelection: false,
                excludePersonalAccountsSelection: false
            },
            appSelectionOptions: null,
            businessOwnerSelection: false,
            canBeShownAtPartnerLevel: true,
            clientSelection: false,
            multiAppSelectionOptions: {
                allSelection: true,
                appSelection: true,
                categorySelection: true,
                lifecycleStageSelection: true,
                managementStageSelection: true,
                platformSelection: true,
                subCategorySelection: true,
                tagSelection: true
            },
            subReportSelection: true,
            tagSelection: true,
            timePeriodSelection: false,
            userSelectionOptions: {
                allSelection: true,
                groupsSelection: true,
                usersSelectionOptions: {
                    multi: true
                }
            },
            vendorIncidentSelection: false
        },
        type: 'discovery'
    },
    {
        checkboxes: [
            {
                reportEndpoint: 'qbrFirst',
                subOptions: [
                    { key: 'SaaSSophisticationScore' },
                    { key: 'Insights' },
                    { key: 'Notes' },
                    { key: 'AppClassificationScore' },
                    { key: 'ManagedAppScore' },
                    { key: 'ShadowITScore' },
                    { key: 'UnapprovedAppScore' },
                    { key: 'AppOverlapScore' },
                    { hidden: true, key: 'ScoreOverview' },
                    { hidden: true, key: 'ScoreOverviewAndGraph' }
                ],
                type: 'QBRFirst'
            }
        ],
        hidden: false,
        setup: {
            advancedReportSelectionOptions: {
                disableBrowsersSelection: true,
                disableInactiveSelection: true,
                disablePersonalSelection: true,
                disableUnclassifiedSelection: true,
                excludeDormantSelection: false,
                excludePersonalAccountsSelection: false
            },
            appSelectionOptions: null,
            businessOwnerSelection: false,
            canBeShownAtPartnerLevel: true,
            clientSelection: false,
            multiAppSelectionOptions: null,
            subReportSelection: true,
            tagSelection: false,
            timePeriodSelection: true,
            userSelectionOptions: null,
            vendorIncidentSelection: false
        },
        type: 'qbr'
    },
    {
        checkboxes: [
            {
                reportEndpoint: 'offboard',
                subOptions: [],
                type: 'UserOffboard'
            }
        ],
        hidden: false,
        setup: {
            advancedReportSelectionOptions: {
                disableBrowsersSelection: true,
                disableInactiveSelection: true,
                disablePersonalSelection: true,
                disableUnclassifiedSelection: true,
                excludeDormantSelection: false,
                excludePersonalAccountsSelection: false
            },
            appSelectionOptions: null,
            businessOwnerSelection: false,
            canBeShownAtPartnerLevel: true,
            clientSelection: false,
            multiAppSelectionOptions: null,
            subReportSelection: false,
            tagSelection: false,
            timePeriodSelection: false,
            userSelectionOptions: {
                allSelection: false,
                groupsSelection: false,
                usersSelectionOptions: {
                    multi: false
                }
            },
            vendorIncidentSelection: false
        },
        type: 'offboard'
    },
    {
        checkboxes: [
            {
                reportEndpoint: 'contracts',
                subOptions: [
                    { key: 'Overview' },
                    { key: 'ApplicationUserDetails' }
                ],
                type: 'Contracts'
            }
        ],
        hidden: false,
        setup: {
            advancedReportSelectionOptions: {
                disableBrowsersSelection: true,
                disableInactiveSelection: true,
                disablePersonalSelection: true,
                disableUnclassifiedSelection: true,
                excludeDormantSelection: false,
                excludePersonalAccountsSelection: false
            },
            appSelectionOptions: { multi: true },
            businessOwnerSelection: false,
            canBeShownAtPartnerLevel: true,
            clientSelection: false,
            multiAppSelectionOptions: null,
            subReportSelection: true,
            tagSelection: false,
            timePeriodSelection: true,
            userSelectionOptions: null,
            vendorIncidentSelection: false
        },
        type: 'contracts'
    },
    {
        checkboxes: [
            {
                reportEndpoint: 'browser',
                subOptions: [{ key: 'Overview' }],
                type: 'Browser'
            }
        ],
        hidden: false,
        selections: {
            users: {
                all: true,
                group: false,
                specific: true
            }
        },
        setup: {
            advancedReportSelectionOptions: null,
            appSelectionOptions: null,
            businessOwnerSelection: false,
            canBeShownAtPartnerLevel: true,
            clientSelection: false,
            multiAppSelectionOptions: null,
            subReportSelection: false,
            tagSelection: false,
            timePeriodSelection: false,
            userSelectionOptions: {
                allSelection: true,
                groupsSelection: false,
                usersSelectionOptions: {
                    multi: true
                }
            },
            vendorIncidentSelection: false
        },
        type: 'browser'
    },
    {
        checkboxes: [
            {
                reportEndpoint: 'usage',
                subOptions: [
                    { key: 'Overview' },
                    { key: 'OverviewBreakdown' },
                    { key: 'VsAdoption' },
                    { key: 'DailyBreakdown' }
                ],
                type: 'Usage'
            },
            {
                reportEndpoint: 'library',
                subOptions: [{ key: 'Overview' }],
                type: 'Library'
            },
            {
                reportEndpoint: 'category',
                subOptions: [{ key: 'Usage' }, { key: 'UsageBreakdown' }],
                type: 'Category'
            }
        ],
        hidden: false,
        setup: {
            advancedReportSelectionOptions: {
                disableBrowsersSelection: true,
                disableInactiveSelection: true,
                disablePersonalSelection: true,
                disableUnclassifiedSelection: true,
                excludeDormantSelection: false,
                excludePersonalAccountsSelection: false
            },
            appSelectionOptions: null,
            businessOwnerSelection: false,
            canBeShownAtPartnerLevel: true,
            clientSelection: false,
            multiAppSelectionOptions: {
                allSelection: true,
                appSelection: true,
                categorySelection: true,
                lifecycleStageSelection: true,
                managementStageSelection: true,
                platformSelection: true,
                subCategorySelection: true,
                tagSelection: true
            },
            subReportSelection: true,
            tagSelection: false,
            timePeriodSelection: true,
            userSelectionOptions: {
                allSelection: true,
                groupsSelection: true,
                usersSelectionOptions: {
                    multi: true
                }
            },
            vendorIncidentSelection: false
        },
        type: 'organizational'
    },
    {
        checkboxes: [
            {
                reportEndpoint: 'businessOwner',
                subOptions: [{ key: 'ApplicationBreakdown' }],
                type: 'BusinessOwner'
            }
        ],
        hidden: false,
        setup: {
            advancedReportSelectionOptions: {
                disableBrowsersSelection: true,
                disableInactiveSelection: true,
                disablePersonalSelection: true,
                disableUnclassifiedSelection: true,
                excludeDormantSelection: false,
                excludePersonalAccountsSelection: false
            },
            appSelectionOptions: null,
            businessOwnerSelection: true,
            canBeShownAtPartnerLevel: true,
            clientSelection: false,
            multiAppSelectionOptions: {
                allSelection: true,
                appSelection: true,
                categorySelection: true,
                lifecycleStageSelection: true,
                managementStageSelection: true,
                platformSelection: true,
                subCategorySelection: true,
                tagSelection: true
            },
            subReportSelection: false,
            tagSelection: false,
            timePeriodSelection: true,
            userSelectionOptions: null,
            vendorIncidentSelection: false
        },
        type: 'businessOwner'
    },
    {
        checkboxes: [
            {
                reportEndpoint: 'productAdoption',
                subOptions: [{ key: 'Overview' }],
                type: 'ProductAdoption'
            }
        ],
        hidden: false,
        setup: {
            advancedReportSelectionOptions: {
                disableBrowsersSelection: true,
                disableInactiveSelection: true,
                disablePersonalSelection: true,
                disableUnclassifiedSelection: true,
                excludeDormantSelection: false,
                excludePersonalAccountsSelection: false
            },
            appSelectionOptions: { multi: true, startWithUnselected: true },
            businessOwnerSelection: false,
            canBeShownAtPartnerLevel: true,
            clientSelection: false,
            multiAppSelectionOptions: null,
            subReportSelection: false,
            tagSelection: false,
            timePeriodSelection: true,
            userSelectionOptions: null,
            vendorIncidentSelection: false
        },
        type: 'productAdoption'
    },
    {
        checkboxes: [
            {
                reportEndpoint: 'applicationOverlap',
                subOptions: [
                    { key: 'CategoryOverview' },
                    { key: 'CategoryBreakdown' }
                ],
                type: 'ApplicationOverlap'
            }
        ],
        hidden: false,
        setup: {
            advancedReportSelectionOptions: {
                disableBrowsersSelection: false,
                disableInactiveSelection: false,
                disablePersonalSelection: true,
                disableUnclassifiedSelection: true,
                excludeDormantSelection: false,
                excludePersonalAccountsSelection: false
            },
            appSelectionOptions: null,
            businessOwnerSelection: false,
            canBeShownAtPartnerLevel: true,
            clientSelection: false,
            multiAppSelectionOptions: {
                allSelection: true,
                appSelection: false,
                categorySelection: true,
                lifecycleStageSelection: false,
                managementStageSelection: false,
                platformSelection: false,
                subCategorySelection: true,
                tagSelection: false
            },
            subReportSelection: true,
            tagSelection: false,
            timePeriodSelection: true,
            userSelectionOptions: null,
            vendorIncidentSelection: false
        },
        type: 'applicationOverlap'
    },
    {
        checkboxes: [
            {
                reportEndpoint: 'microsoftOfficeOverlap',
                subOptions: [
                    { key: 'Overview' },
                    { key: 'OverviewBreakdown' },
                    { key: 'NoOverlapBreakdown' }
                ],
                type: 'MicrosoftOfficeOverlap'
            }
        ],
        hidden: false,
        setup: {
            advancedReportSelectionOptions: {
                disableBrowsersSelection: true,
                disableInactiveSelection: true,
                disablePersonalSelection: true,
                disableUnclassifiedSelection: true,
                excludeDormantSelection: false,
                excludePersonalAccountsSelection: false
            },
            appSelectionOptions: { multi: true },
            businessOwnerSelection: false,
            canBeShownAtPartnerLevel: true,
            clientSelection: false,
            multiAppSelectionOptions: null,
            subReportSelection: true,
            tagSelection: false,
            timePeriodSelection: true,
            userSelectionOptions: null,
            vendorIncidentSelection: false
        },
        type: 'microsoftOfficeOverlap'
    },
    {
        checkboxes: [
            {
                reportEndpoint: 'shadowIT',
                subOptions: [
                    { key: 'Overview' },
                    { key: 'OverviewBreakdown' },
                    { key: 'Breakdown' }
                ],
                type: 'ShadowIT'
            }
        ],
        hidden: false,
        setup: {
            advancedReportSelectionOptions: {
                disableBrowsersSelection: true,
                disableInactiveSelection: true,
                disablePersonalSelection: true,
                disableUnclassifiedSelection: true,
                excludeDormantSelection: false,
                excludePersonalAccountsSelection: false
            },
            appSelectionOptions: null,
            businessOwnerSelection: false,
            canBeShownAtPartnerLevel: true,
            clientSelection: false,
            multiAppSelectionOptions: {
                allSelection: true,
                appSelection: true,
                categorySelection: true,
                lifecycleStageSelection: true,
                managementStageSelection: true,
                platformSelection: true,
                subCategorySelection: true,
                tagSelection: true
            },
            subReportSelection: true,
            tagSelection: false,
            timePeriodSelection: true,
            userSelectionOptions: null,
            vendorIncidentSelection: false
        },
        type: 'shadowIT'
    },
    {
        // Application Map
        checkboxes: [
            {
                reportEndpoint: 'application',
                subOptions: [{ key: 'Overview' }, { key: 'Breakdown' }],
                type: 'Map'
            }
        ],
        hidden: false,
        setup: {
            advancedReportSelectionOptions: {
                disableBrowsersSelection: true,
                disableInactiveSelection: true,
                disablePersonalSelection: true,
                disableUnclassifiedSelection: true,
                excludeDormantSelection: false,
                excludePersonalAccountsSelection: false
            },
            appSelectionOptions: { multi: false, startWithUnselected: true },
            businessOwnerSelection: false,
            canBeShownAtPartnerLevel: true,
            clientSelection: false,
            multiAppSelectionOptions: null,
            subReportSelection: true,
            tagSelection: false,
            timePeriodSelection: true,
            userSelectionOptions: null,
            vendorIncidentSelection: false
        },
        type: 'application'
    },
    {
        checkboxes: [
            {
                reportEndpoint: 'userApps',
                subOptions: [{ key: 'Overview' }],
                type: 'UserApps'
            }
        ],
        hidden: false,
        setup: {
            advancedReportSelectionOptions: {
                disableBrowsersSelection: true,
                disableInactiveSelection: true,
                disablePersonalSelection: true,
                disableUnclassifiedSelection: true,
                excludeDormantSelection: false,
                excludePersonalAccountsSelection: false
            },
            appSelectionOptions: null,
            businessOwnerSelection: false,
            canBeShownAtPartnerLevel: true,
            clientSelection: false,
            multiAppSelectionOptions: {
                allSelection: true,
                appSelection: true,
                categorySelection: true,
                lifecycleStageSelection: true,
                managementStageSelection: true,
                platformSelection: true,
                subCategorySelection: true,
                tagSelection: true
            },
            subReportSelection: false,
            tagSelection: false,
            timePeriodSelection: true,
            userSelectionOptions: {
                allSelection: true,
                groupsSelection: true,
                usersSelectionOptions: {
                    multi: true
                }
            },
            vendorIncidentSelection: false
        },
        type: 'userApps'
    },
    {
        // App Lifecycle
        checkboxes: [
            {
                reportEndpoint: 'status',
                subOptions: [
                    { key: 'Overview' },
                    { key: 'OverviewBreakdown' },
                    { key: 'Breakdown' }
                ],
                type: 'ApplicationLifecycleStage'
            }
        ],
        hidden: false,
        setup: {
            advancedReportSelectionOptions: {
                disableBrowsersSelection: true,
                disableInactiveSelection: true,
                disablePersonalSelection: true,
                disableUnclassifiedSelection: true,
                excludeDormantSelection: false,
                excludePersonalAccountsSelection: false
            },
            appSelectionOptions: null,
            businessOwnerSelection: false,
            canBeShownAtPartnerLevel: true,
            clientSelection: false,
            multiAppSelectionOptions: {
                allSelection: true,
                appSelection: true,
                categorySelection: true,
                lifecycleStageSelection: true,
                managementStageSelection: true,
                platformSelection: true,
                subCategorySelection: true,
                tagSelection: true
            },
            subReportSelection: true,
            tagSelection: false,
            timePeriodSelection: true,
            userSelectionOptions: null,
            vendorIncidentSelection: false
        },
        type: 'status'
    },
    {
        checkboxes: [
            {
                reportEndpoint: 'applicationFunnel',
                subOptions: [
                    { key: 'Breakdown' },
                    { key: 'OverviewBreakdown' }
                ],
                type: 'All'
            }
        ],
        hidden: true,
        // This report does not show up in the report selections
        // This setup needs to be updated when necessary.
        setup: {
            advancedReportSelectionOptions: {
                disableBrowsersSelection: true,
                disableInactiveSelection: true,
                disablePersonalSelection: true,
                disableUnclassifiedSelection: false,
                excludeDormantSelection: false,
                excludePersonalAccountsSelection: false
            },
            appSelectionOptions: null,
            businessOwnerSelection: false,
            canBeShownAtPartnerLevel: null,
            clientSelection: false,
            multiAppSelectionOptions: null,
            subReportSelection: true,
            tagSelection: false,
            timePeriodSelection: false,
            userSelectionOptions: null,
            vendorIncidentSelection: false
        },
        type: 'applicationFunnel'
    },
    {
        checkboxes: [
            {
                reportEndpoint: 'partnerApplicationOverview',
                subOptions: [
                    { key: 'Breakdown' },
                    { key: 'OverviewBreakdown' },
                    { key: 'ApplicationBreakdown' }
                ],
                type: 'ApplicationsUsed'
            },
            {
                reportEndpoint: 'partnerApplicationOverview',
                subOptions: [
                    { key: 'Breakdown' },
                    { key: 'OverviewBreakdown' },
                    { key: 'ApplicationBreakdown' }
                ],
                type: 'ApplicationUsage'
            }
        ],
        hidden: false,
        setup: {
            advancedReportSelectionOptions: {
                disableBrowsersSelection: true,
                disableInactiveSelection: true,
                disablePersonalSelection: true,
                disableUnclassifiedSelection: true,
                excludeDormantSelection: false,
                excludePersonalAccountsSelection: false
            },
            appSelectionOptions: { multi: true },
            businessOwnerSelection: false,
            canBeShownAtPartnerLevel: null,
            clientSelection: false,
            multiAppSelectionOptions: null,
            subReportSelection: true,
            tagSelection: false,
            timePeriodSelection: true,
            userSelectionOptions: null,
            vendorIncidentSelection: false
        },
        type: 'partnerApplicationOverview'
    },
    {
        checkboxes: [
            {
                reportEndpoint: 'partnerBreachImpact',
                subOptions: [{ key: 'Breakdown' }],
                type: 'ClientImpact'
            }
        ],
        hidden: false,
        setup: {
            advancedReportSelectionOptions: {
                disableBrowsersSelection: true,
                disableInactiveSelection: true,
                disablePersonalSelection: true,
                disableUnclassifiedSelection: true,
                excludeDormantSelection: false,
                excludePersonalAccountsSelection: false
            },
            appSelectionOptions: null,
            businessOwnerSelection: false,
            canBeShownAtPartnerLevel: null,
            clientSelection: false,
            multiAppSelectionOptions: null,
            subReportSelection: false,
            tagSelection: false,
            timePeriodSelection: false,
            userSelectionOptions: null,
            vendorIncidentSelection: true
        },
        type: 'partnerBreachImpact'
    },
    {
        checkboxes: [
            {
                reportEndpoint: 'partnerUsers',
                subOptions: [{ key: 'Overview' }],
                type: 'PartnerUsers'
            }
        ],
        hidden: false,
        selections: {
            clients: {
                all: true,
                specific: true
            },
            includeInactive: true
        },
        setup: {
            advancedReportSelectionOptions: null,
            appSelectionOptions: null,
            businessOwnerSelection: false,
            canBeShownAtPartnerLevel: null,
            clientSelection: true,
            multiAppSelectionOptions: null,
            subReportSelection: false,
            tagSelection: false,
            timePeriodSelection: false,
            userSelectionOptions: null,
            vendorIncidentSelection: false
        },
        type: 'partnerUsers'
    },
    {
        checkboxes: [
            {
                reportEndpoint: 'partnerApplicationUsage',
                subOptions: [{ key: 'TopApplicationsUsedLastWeek' }],
                type: 'TopApplicationsUsed'
            }
        ],
        hidden: true,
        // This report does not show up in the report selections
        // This setup needs to be updated when necessary.
        setup: {
            advancedReportSelectionOptions: {
                disableBrowsersSelection: true,
                disableInactiveSelection: true,
                disablePersonalSelection: true,
                disableUnclassifiedSelection: false,
                excludeDormantSelection: false,
                excludePersonalAccountsSelection: false
            },
            appSelectionOptions: null,
            businessOwnerSelection: false,
            canBeShownAtPartnerLevel: null,
            clientSelection: false,
            multiAppSelectionOptions: null,
            subReportSelection: true,
            tagSelection: false,
            timePeriodSelection: false,
            userSelectionOptions: null,
            vendorIncidentSelection: false
        },
        type: 'partnerApplicationUsage'
    },
    {
        checkboxes: [
            {
                reportEndpoint: 'partnerClientDeploymentStage',
                subOptions: [
                    { key: 'Breakdown' },
                    { key: 'OverviewBreakdown' }
                ],
                type: 'ClientStages'
            }
        ],
        hidden: true,
        // This report does not show up in the report selections
        // This setup needs to be updated when necessary.
        setup: {
            advancedReportSelectionOptions: {
                disableBrowsersSelection: true,
                disableInactiveSelection: true,
                disablePersonalSelection: true,
                disableUnclassifiedSelection: false,
                excludeDormantSelection: false,
                excludePersonalAccountsSelection: false
            },
            appSelectionOptions: null,
            businessOwnerSelection: false,
            canBeShownAtPartnerLevel: null,
            clientSelection: false,
            multiAppSelectionOptions: null,
            subReportSelection: true,
            tagSelection: false,
            timePeriodSelection: false,
            userSelectionOptions: null,
            vendorIncidentSelection: false
        },
        type: 'partnerClientDeploymentStage'
    }
];
